import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

/**
 * BrandingProvider applies tenant branding colors as CSS custom properties
 * to the document root. This allows all components to use the brand colors
 * via CSS variables like var(--brand-primary).
 */
const BrandingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { branding } = useAuth();

  useEffect(() => {
    // Apply branding colors as CSS custom properties
    const root = document.documentElement;
    root.style.setProperty('--brand-primary', branding.primary_color);
    root.style.setProperty('--brand-secondary', branding.secondary_color);
    root.style.setProperty('--brand-name', branding.name);

    // Also set derived colors (lighter/darker variants)
    root.style.setProperty('--brand-primary-light', `${branding.primary_color}20`);
    root.style.setProperty('--brand-primary-dark', branding.primary_color);
  }, [branding]);

  return <>{children}</>;
};

export default BrandingProvider;
